import { IDirectDebitRequest } from '../@types/directDebits';
import axios from '../utils/axios';

export class DirectDebitsService {
  getAllDirectDebits() {
    return axios.get('/direct-debits');
  }

  exportDirectDebitRecords(query?: string) {
    return axios.get(`/direct-debits/export/csv${query ? `?${query}` : ''}`, {
      responseType: 'text'
    });
  }

  getDirectDebit(directDebitId: number) {
    return axios.get(`/direct-debits/${directDebitId}`);
  }

  createDirectDebit(data: IDirectDebitRequest) {
    return axios.post('/direct-debits', data);
  }

  updateDirectDebit(id: number, data: Partial<IDirectDebitRequest>) {
    return axios.put(`/direct-debits/${id}`, data);
  }

  deleteDirectDebit(id: number) {
    return axios.delete(`/direct-debits/${id}`);
  }
}